import {
  Alert,
  Box,
  BoxProps,
  Button,
  Chip,
  CircularProgress,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import { ReactComponent as ArrowRightLeft } from "../../assets/walletIcons/arrow-right-arrow-left.svg";
import { ReactComponent as ChipBlue } from "../../assets/walletIcons/chip-blue.svg";
import { ReactComponent as ChipPink } from "../../assets/walletIcons/chip-pink.svg";
import { ReactComponent as DollarSign } from "../../assets/walletIcons/dollar-sign.svg";
import { ReactComponent as ArrowRightWhite } from "../../assets/jobIcons/arrow-right-white.svg";
import { ReactComponent as ArrowRightGray } from "../../assets/jobIcons/arrow-right-gray.svg";
import React, { useEffect, useState } from "react";
import PaymentForm from "./PaymentForm";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import ByteChip from "../icons/ByteChip";

export interface PaymentParams {
  currencyAmount: number;
  amount: number;
  clientSecret: string;
  currency: string;
}

export type TopUpFormProps = {
  box?: BoxProps;
  paymentParams: PaymentParams;
};

const stripeKey =
  document.querySelector('meta[name="stripe-key"]')?.getAttribute("content") ||
  "...";
if (!stripeKey) {
  throw new Error(`No stripe key (${stripeKey})`);
}
const stripePromise = loadStripe(stripeKey);

const StripeForm = ({ box, paymentParams }: TopUpFormProps) => {
  const boxProps = { ...box };
  const { currencyAmount, currency, clientSecret, amount } = paymentParams;
  const [isReady, setIsReady] = useState(false);

  return (
    <Box
      className="TopUpForm"
      {...boxProps}
      justifyContent="center"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      {isReady ? (
        <Box mb={1}>
          <Stack direction={"row"} alignItems={"center"} gap={"1px"}>
            <ByteChip color="textPrimary" size="xs" />
            <Typography variant="body1" mt={"2px"}>
              {amount}
            </Typography>
          </Stack>
        </Box>
      ) : (
        <Box my={2}>
          <CircularProgress></CircularProgress>
        </Box>
      )}
      <Box mt={2}>
        {clientSecret ? (
          <Elements
            stripe={stripePromise}
            options={{ clientSecret: clientSecret }}
          >
            <PaymentForm onReady={() => setIsReady(true)} amount={amount} />
          </Elements>
        ) : null}
      </Box>
    </Box>
  );
};

export default StripeForm;
